import React from "react";
import {getTranslatedCountry} from "../../../lib/intlUtils";

export interface CountryRenderProps {
    countryCode: string;
    locale?: string;
}

export function CountryRender(props: CountryRenderProps) {
    return <>{getTranslatedCountry(props.countryCode, props.locale)}</>
}
